import * as ayah from './ayah';
import * as captcha from './captcha';
import * as cmahasiswa from './cmahasiswa';
import * as ibu from './ibu';
import * as info from './info';
import * as kabkot from './kabkot';
import * as kecamatan from './kecamatan';
import * as kendaraan from './kendaraan';
import * as listrik from './listrik';
import * as provinsi from './provinsi';
import * as pendukung from './pendukung';
import * as pekerjaan from './pekerjaan';
import * as rumah from './rumah';
import * as ukt from './ukt';
import * as user from './user';
import * as wali from './wali';
import * as verifikasi from './verifikasi';
import * as keringanan from './keringanan';

export {
    ayah,
    captcha,
    cmahasiswa,
    ibu,
    info,
    kabkot,
    kecamatan,
    kendaraan,
    listrik,
    provinsi,
    pendukung,
    pekerjaan,
    rumah,
    ukt,
    user,
    wali,
    verifikasi,
    keringanan,
};
